import React, { useState, Context, ReactElement, Component } from "react";


const ReloadServiceListContext: Context<[boolean, React.Dispatch<React.SetStateAction<boolean>>]> = React.createContext<[boolean, React.Dispatch<React.SetStateAction<boolean>>]>([false, (_value: any) => { }]);

const ReloadServiceListProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [reload_service_list, set_reload_service_list]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState(()=> false);
    return (
        <ReloadServiceListContext.Provider value={[reload_service_list, set_reload_service_list]}>
            {props.children}
        </ReloadServiceListContext.Provider>
    )
}

export { ReloadServiceListContext, ReloadServiceListProvider };
